import { render, staticRenderFns } from "./invoice-list.vue?vue&type=template&id=08eecddd&"
import script from "./invoice-list.vue?vue&type=script&lang=js&"
export * from "./invoice-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports